import React, { ReactNode } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ThemeProvider, OmSpinner } from '@owma/kit'

import i18n from 'i18n'

import { type LocaleKey } from './localizationUtils'

export { isAvailable, getAvailableLocale } from './localizationUtils'
export type { LocaleKey } from './localizationUtils'

interface RootState {
  settings: {
    // locale 은 local-only — localSettings.general.locale 에 있다(서버 sync 대상 아님).
    localSettings?: {
      general?: {
        locale?: LocaleKey
      }
    }
  }
}

const mapStateToProps = (state: RootState) => ({
  // locale 은 local-only — localSettings.general.locale 에서 읽는다(서버 sync 대상 아님).
  locale: state.settings.localSettings?.general?.locale ?? 'ko-KR',
})

const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface LocalizationProps extends PropsFromRedux {
  children: ReactNode
}

interface LocalizationState {
  localeInitialized: boolean
}

class Localization extends React.Component<LocalizationProps, LocalizationState> {
  state: LocalizationState = {
    localeInitialized: false,
  }

  componentDidMount(): void {
    const { dispatch, locale } = this.props
    const initLocale = (): void => {
      const isChanged = i18n.language !== locale
      if (isChanged === true) {
        dispatch({
          type: 'settings/SET_LOCALE',
          payload: {
            locale,
          },
        })
      }
      this.setState({ localeInitialized: true })
    }
    if (i18n.isInitialized === true) {
      initLocale()
    } else {
      i18n.on('initialized', () => {
        initLocale()
      })
    }
  }

  render(): React.ReactElement {
    const { localeInitialized } = this.state
    const { children } = this.props

    // Modal.confirm(radix) 기본 OK/Cancel 텍스트를 현재 로케일 i18next 로 공급(구 ConfigProvider locale 대체).
    const component =
      localeInitialized === true ? (
        <ThemeProvider
          confirmDefaults={{
            okText: i18n.t('common.button.ok'),
            cancelText: i18n.t('common.button.cancel'),
          }}
        >
          {children}
        </ThemeProvider>
      ) : (
        <OmSpinner size="large" />
      )

    return component
  }
}

export default connector(Localization)
